var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2257_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00075 18.0015C10.7809 18.0015 12.5211 17.4736 14.0013 16.4846C15.4815 15.4956 16.6351 14.0899 17.3164 12.4452C17.9976 10.8005 18.1758 8.99077 17.8286 7.2448C17.4813 5.49882 16.624 3.89504 15.3652 2.63626C14.1065 1.37749 12.5027 0.520247 10.7567 0.172951C9.01073 -0.174345 7.20098 0.0038999 5.55631 0.685145C3.91164 1.36639 2.50592 2.52004 1.5169 4.00021C0.527885 5.48037 0 7.22057 0 9.00075C0 11.3879 0.948291 13.6773 2.63626 15.3652C4.32423 17.0532 6.6136 18.0015 9.00075 18.0015Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.48 1.86318C13.5478 1.14571 12.4838 0.618201 11.3485 0.310547V4.99244L14.48 1.86318ZM0.310547 6.65533C0.616824 5.51851 1.14445 4.45332 1.86318 3.52081L4.99469 6.65608L0.310547 6.65533ZM16.1369 3.52006C16.8551 4.45318 17.3826 5.51851 17.6895 6.65533H13.0076L16.1369 3.52006ZM0.310547 11.35H4.99244L1.86318 14.4792C1.14588 13.5478 0.618365 12.4846 0.310547 11.35ZM3.52156 16.1399C4.45407 16.8561 5.51798 17.3826 6.65308 17.6895V13.0106L3.52156 16.1399ZM3.52156 1.86018C4.45376 1.1434 5.51777 0.616873 6.65308 0.310547V4.99244L3.52156 1.86018ZM11.3477 17.6895C12.4831 17.3829 13.5471 16.8562 14.4792 16.1391L11.3477 13.0099V17.6895ZM16.1391 14.4792L13.0076 11.3515H17.6895C17.3828 12.4861 16.856 13.5494 16.1391 14.4807V14.4792Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9252 7.8253H10.1748V0.0749016C9.3952 -0.0249672 8.60602 -0.0249672 7.82639 0.0749016V7.82455H0.0737408C-0.0278355 8.60457 -0.0278355 9.39447 0.0737408 10.1745H7.82639V17.9249C8.60602 18.0248 9.3952 18.0248 10.1748 17.9249V10.1745H17.9252C18.0268 9.39472 18.0268 8.60507 17.9252 7.8253ZM11.3509 11.3506L15.3645 15.3657L15.8933 14.7859L12.455 11.3513H11.3487L11.3509 11.3506ZM2.63745 15.3649L6.65329 11.3498V12.4547L3.215 15.8937L2.63745 15.3649ZM6.65254 6.64995L2.63745 2.63637L2.11241 3.21616L5.5492 6.6567H6.65554L6.65254 6.64995ZM15.3638 2.63637L11.3487 6.64995V5.54286L14.787 2.10307L15.3638 2.63637Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2257_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/EnglishFlag.b3c68e6552a3866a4dba93c3d89adf62.svg";
export { ForwardRef as ReactComponent };